import { FC } from 'react';
import { Box, BoxProps, Card } from '@qga/roo-ui/components';
import ContentHeading from 'components/Typography/ContentHeading';
import HorizontalRule from 'components/Layout/HorizontalRule';
import { FormattedCalendarDate } from 'components/Formatters';
import { ItemGroup, GroupHeading, GroupItems, Item } from 'components/ReviewCard';

interface RequestDetailsProps extends BoxProps {
  checkIn: string;
  checkOut: string;
  phoneNumber: string;
  email: string;
}

const RequestDetails: FC<RequestDetailsProps> = ({ checkIn, checkOut, phoneNumber, email, ...rest }) => (
  <Box {...rest}>
    <ContentHeading mb={4} fontSize={['xl', '2xl']}>
      Request details
    </ContentHeading>
    <Card p={0}>
      <ItemGroup>
        <GroupHeading>New stay dates</GroupHeading>
        <GroupItems>
          <Item labelItem="Check-in" valueItem={<FormattedCalendarDate date={checkIn} />} boldValue />
          <Item labelItem="Check-out" valueItem={<FormattedCalendarDate date={checkOut} />} boldValue />
        </GroupItems>
      </ItemGroup>
      <HorizontalRule mx={[0, 5]} my={0} />
      <ItemGroup>
        <GroupHeading>Your contact details</GroupHeading>
        <GroupItems>
          <Item labelItem="Phone number" valueItem={phoneNumber} />
          <Item labelItem="Email" valueItem={email} />
        </GroupItems>
      </ItemGroup>
    </Card>
  </Box>
);

export default RequestDetails;
